module.exports = __webpack_public_path__ + "static/media/rent.da9f7faa.jpg";